import http from '../../utils/Http/Http'
import { useQuery } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import { useEffect } from 'react'

export const getUserAgents = async ({ userId, limit }) => {
	const url = '/agents'
	const params = { user_id: userId, limit: 10000 }
	params.limit = limit ? limit : params.limit

	const res = await http({
		url,
		params,
		method: 'get',
	})

	return { agents: res.data.agents, loadMore: !!res.data.next_page_start_key }
}

export default function useFetchAgentsList(queryKey, limit) {
	const { currentUser } = getAuth()
	const {
		data: { agents = [], loadMore } = {},
		isFetching: fetchingAgents,
		refetch: refetchAgents,
		isRefetching,
		error,
	} = useQuery({
		queryKey,
		queryFn: () =>
			getUserAgents({
				userId: currentUser.uid,
				limit: limit || process.env.REACT_APP_DEFAULT_PAGING,
			}),
	})

	useEffect(() => {
		refetchAgents()
	}, [limit])

	return { agents, fetchingAgents, isRefetching, refetchAgents, loadMore, error }
}
